import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { INFO_TOOLTIP_HIDE_DELAY } from '../../constants/componentDefaults';

export const infoIcon = () => (
	<span
		style={{ width: 20, transform: 'translateY(1px)' }}
		className="text-center text-secondary glyphicons glyphicons-circle-info clickable b-left d-inline-block p-0 chip-glyphicon"
	/>
);

const Tooltip = ({
	children,
	renderPopoverContent,
	renderPopoverTitle = null,
	hideDelay = INFO_TOOLTIP_HIDE_DELAY,
}) => {
	Tooltip.displayName = 'Tooltip';
	const renderPopover = (
		<Popover id="popover-basic">
			<Popover.Header>{renderPopoverTitle && renderPopoverTitle()}</Popover.Header>
			<Popover.Body>{renderPopoverContent()}</Popover.Body>
		</Popover>
	);
	return (
		<OverlayTrigger
			key="soob-info-trigger"
			placement="top"
			delay={{ hide: hideDelay }}
			overlay={renderPopover}>
			{children}
		</OverlayTrigger>
	);
};

export default Tooltip;
